import React from 'react';
import UserPanel from '../components/UserPanel';
import TicketsButton from '../components/TicketsPanel';
import SetupGuide from '../components/SetupGuide';
import LangSwitcher from '../components/LangSwitcher';
import { useSite } from '../context/SiteContext';
import { useT } from '../i18n';

const UserHome = () => {
  const { site } = useSite();
  const t = useT();
  return (
    <div className="home">
      {/* ========== 顶部导航栏 ========== */}
      <header className="navbar">
        <div className="navbar__inner">
          <a href="/" className="navbar__brand">
            <img src="/logo.svg" alt="" className="navbar__logo" />
            <span className="navbar__title">{site.site_name} · {t('导航.用户面板')}</span>
          </a>
          <div className="navbar__actions" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <TicketsButton />
            <LangSwitcher variant="navbar" />
          </div>
        </div>
      </header>

      {/* ========== 公告栏(导航栏下方,横向滚动) ========== */}
      {site.announcement && (
        <div className="announcement">
          <div className="announcement__inner">
            <span className="announcement__tag">系统公告</span>
            <div className="announcement__viewport">
              <span className="announcement__text">{site.announcement}</span>
            </div>
          </div>
        </div>
      )}

      {/* ========== 主体 ========== */}
      <main className="home__main">
        {/* 4 格卡横铺整宽(与 minnimax 一致) */}
        <UserPanel.QuadGrid />

        {/* 左右两栏:左=下方卡片,右=接入说明粘性侧栏 */}
        <div className="main-grid">
          <div className="main-col main-col--left">
            <UserPanel.Body />
          </div>

          <aside className="main-col main-col--right">
            <SetupGuide />
          </aside>
        </div>
      </main>
    </div>
  );
};

export default UserHome;